import {
  SUBSCRIPTION_STATUS_VALUES,
  SUBSCRIPTION_STATUS_VALUES_WITH_PENDING_CANCEL,
  CURRENCY_COOKIE_NAME,
  SUBSCRIPTION_STATUS_COOKIE_NAME,
  WORDPRESS_LOGIN_COOKIE_NAME,
  SUBSCRIPTION_STATUS_COOKIE_VALUES,
  COUNTRY_COOKIE_NAME,
  ON_HOLD,
  STUDIO_AI_SUBSCRIPTION_STATUS_COOKIE_NAME,
} from 'constants/cookies'
import type { Condition } from '../types'
import { CurrencyCode } from 'codegen/types'

export const LOGGED_OUT: Condition = {
  type: 'cookie',
  cookieName: WORDPRESS_LOGIN_COOKIE_NAME,
  operator: 'NOT_EXISTS',
}

export const LOGGED_IN: Condition = {
  type: 'cookie',
  cookieName: WORDPRESS_LOGIN_COOKIE_NAME,
  operator: 'EXISTS',
}

export const HAS_ALL_ACCESS: Condition = {
  type: 'cookie',
  cookieName: SUBSCRIPTION_STATUS_COOKIE_NAME,
  expectedValue: Object.values(SUBSCRIPTION_STATUS_VALUES),
  operator: 'IN',
}

export const DOES_NOT_HAVE_ALL_ACCESS: Condition = {
  type: 'cookie',
  cookieName: SUBSCRIPTION_STATUS_COOKIE_NAME,
  expectedValue: Object.values(SUBSCRIPTION_STATUS_VALUES),
  operator: 'NOT_IN',
}

export const HAS_ALL_ACCESS_WITH_PENDING_CANCEL: Condition = {
  type: 'cookie',
  cookieName: SUBSCRIPTION_STATUS_COOKIE_NAME,
  expectedValue: Object.values(SUBSCRIPTION_STATUS_VALUES_WITH_PENDING_CANCEL),
  operator: 'IN',
}

export const DOLLAR_CURRENCY: Condition = {
  type: 'cookie',
  cookieName: CURRENCY_COOKIE_NAME,
  expectedValue: CurrencyCode.Usd.toUpperCase(),
  operator: 'EQUALS',
}

export const LEGACY_PENDING_CANCEL: Condition = {
  type: 'cookie',
  cookieName: SUBSCRIPTION_STATUS_COOKIE_NAME,
  expectedValue: [
    SUBSCRIPTION_STATUS_COOKIE_VALUES.TRIAL_LEGACY_PENDING_CANCEL,
    SUBSCRIPTION_STATUS_COOKIE_VALUES.SUBSCRIPTION_LEGACY_PENDING_CANCEL,
  ],
  operator: 'IN',
}

export const NOT_NL_COUNTRY: Condition = {
  type: 'cookie',
  cookieName: COUNTRY_COOKIE_NAME,
  expectedValue: 'NL',
  operator: 'NOT_EQUALS',
}

export const NL_COUNTRY: Condition = {
  type: 'cookie',
  cookieName: COUNTRY_COOKIE_NAME,
  expectedValue: 'NL',
  operator: 'EQUALS',
}

export const NO_SUBSCRIPTION: Condition = {
  type: 'cookie',
  cookieName: SUBSCRIPTION_STATUS_COOKIE_NAME,
  expectedValue: SUBSCRIPTION_STATUS_COOKIE_VALUES.NO_SUBSCRIPTION,
  operator: 'EQUALS',
}

export const IN_ON_HOLD_SUBSCRIPTION_ALL_ACCESS: Condition = {
  type: 'cookie',
  cookieName: SUBSCRIPTION_STATUS_COOKIE_NAME,
  expectedValue: [ON_HOLD.SUBSCRIPTION, ON_HOLD.TRIAL],
  operator: 'IN',
}

export const IN_ON_HOLD_SUBSCRIPTION_STUDIO_AI: Condition = {
  type: 'cookie',
  cookieName: STUDIO_AI_SUBSCRIPTION_STATUS_COOKIE_NAME,
  expectedValue: [ON_HOLD.SUBSCRIPTION, ON_HOLD.TRIAL],
  operator: 'IN',
}

export const IN_YEARLY_TRIAL: Condition = {
  type: 'cookie',
  cookieName: SUBSCRIPTION_STATUS_COOKIE_NAME,
  expectedValue: SUBSCRIPTION_STATUS_COOKIE_VALUES.TRIAL_ACTIVE_YEARLY,
  operator: 'EQUALS',
}

export const NOT_IN_STUDIO_AI_ACTIVE_OR_TRIAL: Condition = {
  type: 'cookie',
  cookieName: STUDIO_AI_SUBSCRIPTION_STATUS_COOKIE_NAME,
  expectedValue: [
    SUBSCRIPTION_STATUS_COOKIE_VALUES.TRIAL_ACTIVE_YEARLY,
    SUBSCRIPTION_STATUS_COOKIE_VALUES.PAID_SUBSCRIPTION_ACTIVE_YEARLY,
  ],
  operator: 'NOT_IN',
}

export const NOT_IN_YEARLY_TRIAL: Condition = {
  type: 'cookie',
  cookieName: SUBSCRIPTION_STATUS_COOKIE_NAME,
  expectedValue: SUBSCRIPTION_STATUS_COOKIE_VALUES.TRIAL_ACTIVE_YEARLY,
  operator: 'NOT_EQUALS',
}

export const IN_YEARLY: Condition = {
  type: 'cookie',
  cookieName: SUBSCRIPTION_STATUS_COOKIE_NAME,
  expectedValue: SUBSCRIPTION_STATUS_COOKIE_VALUES.PAID_SUBSCRIPTION_ACTIVE_YEARLY,
  operator: 'EQUALS',
}

export const IN_MONTHLY: Condition = {
  type: 'cookie',
  cookieName: SUBSCRIPTION_STATUS_COOKIE_NAME,
  expectedValue: [
    SUBSCRIPTION_STATUS_COOKIE_VALUES.TRIAL_ACTIVE_MONTHLY,
    SUBSCRIPTION_STATUS_COOKIE_VALUES.PAID_SUBSCRIPTION_ACTIVE_MONTHLY,
  ],
  operator: 'IN',
}

export const NOT_IN_MONTHLY: Condition = {
  type: 'cookie',
  cookieName: SUBSCRIPTION_STATUS_COOKIE_NAME,
  expectedValue: [
    SUBSCRIPTION_STATUS_COOKIE_VALUES.TRIAL_ACTIVE_MONTHLY,
    SUBSCRIPTION_STATUS_COOKIE_VALUES.PAID_SUBSCRIPTION_ACTIVE_MONTHLY,
  ],
  operator: 'NOT_IN',
}

export const IN_PENDING_CANCEL: Condition = {
  type: 'cookie',
  cookieName: SUBSCRIPTION_STATUS_COOKIE_NAME,
  expectedValue: [
    SUBSCRIPTION_STATUS_COOKIE_VALUES.TRIAL_PENDING_CANCEL,
    SUBSCRIPTION_STATUS_COOKIE_VALUES.SUBSCRIPTION_PENDING_CANCEL,
  ],
  operator: 'IN',
}

export const STUDIO_AI_IN_PENDING_CANCEL: Condition = {
  type: 'cookie',
  cookieName: STUDIO_AI_SUBSCRIPTION_STATUS_COOKIE_NAME,
  expectedValue: [
    SUBSCRIPTION_STATUS_COOKIE_VALUES.TRIAL_PENDING_CANCEL,
    SUBSCRIPTION_STATUS_COOKIE_VALUES.SUBSCRIPTION_PENDING_CANCEL,
  ],
  operator: 'IN',
}
